import { render, staticRenderFns } from "./relatePermissionDeptDialog.vue?vue&type=template&id=0f7ae380&"
import script from "./relatePermissionDeptDialog.vue?vue&type=script&lang=js&"
export * from "./relatePermissionDeptDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports